/* HaloTack — storefront behaviour (no dependencies) */

(function () {

  if (window.__htInit) return;

  window.__htInit = true;



  var money = function (cents) {

    var v = (Number(cents) || 0) / 100;

    var whole = Math.round(v * 100) % 100 === 0;

    try {

      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(v);

    } catch (e) { return '$' + (whole ? v.toFixed(0) : v.toFixed(2)); }

  };



  var addDays = function (n) {

    var d = new Date(), added = 0;

    while (added < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) added++; }

    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

  };



/* ---------- Buy box ---------- */

  function initBuybox(root) {

    if (root.__ht) return; root.__ht = true;

    var dataEl = root.querySelector('[data-ht-variants]');

    if (!dataEl) return;

    var variants = [];

    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }



    var $ = function (s) { return root.querySelector(s); };

    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var main = $('[data-ht-main]');

    var slides = main ? $$('.ht-bb__slide') : [];

    var thumbs = $$('[data-ht-thumb]');

    var count = $('[data-ht-count]');

    var idInput = $('[data-ht-id]');

    var addBtn = $('[data-ht-add]');

    var buyBtn = $('[data-ht-buy]');

    var msg = $('[data-ht-msg]');

    var low = parseInt(root.dataset.low || '10', 10);

    var current = null;
    var adding = false;



    /* gallery */

    var goTo = function (i, smooth) {

      if (!main || !slides[i]) return;

      main.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });

    };

    var activeIndex = function () { return main ? Math.round(main.scrollLeft / Math.max(1, main.clientWidth)) : 0; };

    if (main) {

      var t;

      main.addEventListener('scroll', function () {

        clearTimeout(t);

        t = setTimeout(function () {

          var i = activeIndex();

          thumbs.forEach(function (b, k) { b.classList.toggle('is-on', k === i); });

          if (count) count.textContent = (i + 1) + ' / ' + slides.length;

          slides.forEach(function (s, k) { var v = s.querySelector('video'); if (v) { if (k === i) { v.play && v.play().catch(function(){}); } else { v.pause && v.pause(); } } });

        }, 60);

      }, { passive: true });

      var prev = $('[data-ht-prev]'), next = $('[data-ht-next]');

      if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, activeIndex() - 1)); });

      if (next) next.addEventListener('click', function () { goTo((activeIndex() + 1) % slides.length); });

      thumbs.forEach(function (b) { b.addEventListener('click', function () { goTo(parseInt(b.dataset.htThumb, 10)); }); });

    }



    /* options */

    var selected = function () {

      var sel = [];

      $$('[data-ht-opt]:checked').forEach(function (inp) { sel[parseInt(inp.dataset.htOpt, 10)] = inp.value; });

      return sel;

    };

    var match = function (sel) {

      return variants.find(function (v) { return v.options.every(function (o, i) { return sel[i] === undefined || sel[i] === o; }); });

    };



    var upTotal = function () {

      var sum = 0, any = false;

      $$('[data-ht-up]').forEach(function (cb) {

        if (!cb.checked) return;

        var row = cb.closest('.ht-up'); var sel = row.querySelector('[data-ht-upv]');

        var price = sel.tagName === 'SELECT' ? sel.options[sel.selectedIndex].dataset.price : sel.dataset.price;

        sum += Number(price) || 0; any = true;

      });

      var totalRow = $('[data-ht-total-row]');

      if (totalRow) {

        totalRow.hidden = !any;

        var tot = $('[data-ht-total]');

        if (tot && current) tot.textContent = money(current.price + sum);

      }

    };



    var stockLine = function (v) {

      var box = $('[data-ht-stock]'); if (!box) return;

      var show = v && v.available && v.managed === 'shopify' && v.qty > 0 && v.qty <= low;

      box.hidden = !show;

      if (!show) return;

      var colorName = (selected().filter(Boolean)[0]) || '';

      var text = (root.dataset.lowText || 'Only [qty] left').replace('[qty]', v.qty).replace('[option]', colorName);

      $('[data-ht-stock-text]').textContent = text;

      var bar = $('[data-ht-stock-bar]'); if (bar) bar.style.width = Math.max(8, Math.round(v.qty / low * 100)) + '%';

    };



    var refreshTiers = function (sel) {

      $$('[data-ht-tier-price]').forEach(function (el) {

        var val = el.dataset.htTierPrice;

        var test = sel.slice();

        var packIdx = null;

        $$('[data-ht-opt]').forEach(function (inp) { if (inp.value === val) packIdx = parseInt(inp.dataset.htOpt, 10); });

        if (packIdx === null) return;

        test[packIdx] = val;

        var v = match(test); if (!v) return;

        el.textContent = money(v.price);

        var old = root.querySelector('[data-ht-tier-old="' + CSS.escape(val) + '"]'); if (old) old.textContent = v.compare > v.price ? money(v.compare) : '';

        var sv = root.querySelector('[data-ht-tier-save="' + CSS.escape(val) + '"]'); if (sv) sv.textContent = v.compare > v.price ? 'Save ' + money(v.compare - v.price) : '';

        var per = root.querySelector('[data-ht-tier-per="' + CSS.escape(val) + '"]'); if (per) per.textContent = money(Math.floor(v.price / (parseInt(per.dataset.units, 10) || 1))) + ' ' + (per.dataset.label || 'each');

      });

    };



    var syncUpsellColours = function (sel) {

      var names = sel.filter(Boolean).map(function (s) { return s.toLowerCase(); });

      $$('select[data-ht-upv]').forEach(function (s) {

        for (var i = 0; i < s.options.length; i++) {

          if (names.indexOf(s.options[i].text.toLowerCase()) > -1) { s.selectedIndex = i; break; }

        }

        var row = s.closest('.ht-up'); var pr = row && row.querySelector('[data-ht-up-price]');

        if (pr) pr.textContent = money(s.options[s.selectedIndex].dataset.price);

      });

    };



    var update = function (fromUser) {

      var sel = selected();

      var v = match(sel);

      current = v || null;

      root.__htCurrent = current;

      sel.forEach(function (val, i) { var l = root.querySelector('[data-ht-opt-label="' + i + '"]'); if (l) l.textContent = val; });

      if (!v) {

        if (addBtn) { addBtn.disabled = true; addBtn.querySelector('[data-ht-add-label]').textContent = 'Unavailable'; }

        if (buyBtn) buyBtn.disabled = true;

        return;

      }

      if (idInput) idInput.value = v.id;

      var now = $('[data-ht-now]'); if (now) now.textContent = money(v.price);

      var old = $('[data-ht-old]'), save = $('[data-ht-save]'), amt = $('[data-ht-save-amt]'), note = $('[data-ht-save-note]');

      var has = v.compare > v.price;

      if (old) { old.hidden = !has; old.textContent = has ? money(v.compare) : ''; }

      if (save) save.hidden = !has;

      if (amt) amt.textContent = has ? money(v.compare - v.price) : '';

      if (note) note.hidden = !has;

      if (addBtn) {

        addBtn.disabled = !v.available;

        addBtn.querySelector('[data-ht-add-label]').textContent = v.available ? (addBtn.dataset.label || addBtn.querySelector('[data-ht-add-label]').textContent) : 'Sold out';

      }

      if (buyBtn) buyBtn.disabled = !v.available;

      stockLine(v);

      refreshTiers(sel);

      syncUpsellColours(sel);

      upTotal();

      if (fromUser && v.media && main) {

        var idx = slides.findIndex(function (s) { return s.dataset.mediaId === String(v.media); });

        if (idx > -1) goTo(idx);

      }

      if (fromUser && window.history && window.history.replaceState && /\/products\//.test(location.pathname)) {

        var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());

      }



      root.dispatchEvent(new CustomEvent('ht:variant', { detail: v, bubbles: true }));

    };

    if (addBtn) addBtn.dataset.label = addBtn.querySelector('[data-ht-add-label]').textContent;



    $$('[data-ht-opt]').forEach(function (inp) { inp.addEventListener('change', function () { update(true); }); });

    $$('[data-ht-up]').forEach(function (cb) { cb.addEventListener('change', upTotal); });

    $$('select[data-ht-upv]').forEach(function (s) {

      s.addEventListener('change', function () {

        var pr = s.closest('.ht-up').querySelector('[data-ht-up-price]');

        if (pr) pr.textContent = money(s.options[s.selectedIndex].dataset.price);

        upTotal();

      });

    });

    var more = $('[data-ht-up-show]');

    if (more) more.addEventListener('click', function () { $$('[data-ht-up-more]').forEach(function (r) { r.hidden = false; }); more.remove(); });



    /* add to cart */

    var add = function (dest, btn) {

      if (!current || !current.available || adding) return;
      adding = true;
      if (addBtn) addBtn.disabled = true;
      if (buyBtn) buyBtn.disabled = true;

      var items = [{ id: current.id, quantity: 1 }];

      $$('[data-ht-up]').forEach(function (cb) {

        if (!cb.checked) return;

        var sel = cb.closest('.ht-up').querySelector('[data-ht-upv]');

        items.push({ id: Number(sel.value), quantity: 1 });

      });

      if (msg) msg.textContent = '';

      btn.classList.add('is-busy');

      var root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

      fetch(root_url + 'cart/add.js', {

        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },

        body: JSON.stringify({ items: items })

      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })

        .then(function (res) {

          if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Could not add to cart');

          var go = function () {

            var url = root_url + (dest === 'checkout' ? 'checkout' : 'cart');



            window.location.href = url;

          };



          go();

        })

        .catch(function (e) { adding = false; btn.classList.remove('is-busy'); if (addBtn) addBtn.disabled = !current.available; if (buyBtn) buyBtn.disabled = !current.available; if (msg) msg.textContent = e.message; });

    };

    if (addBtn) addBtn.addEventListener('click', function () { add(root.dataset.afterAdd === 'checkout' ? 'checkout' : 'cart', addBtn); });

    if (buyBtn) buyBtn.addEventListener('click', function () { add('checkout', buyBtn); });



    /* delivery estimate */

    var eta = $('[data-ht-eta]');

    if (eta && root.dataset.etaText) {

      var a = parseInt(root.dataset.etaMin || '5', 10), b = parseInt(root.dataset.etaMax || '8', 10);

      eta.querySelector('[data-ht-eta-text]').textContent = root.dataset.etaText.replace('[start]', addDays(Math.min(a, b))).replace('[end]', addDays(Math.max(a, b)));

      eta.hidden = false;

    }



    update(false);



    /* sticky bar */

    var sticky = document.querySelector('[data-ht-sticky]');

    if (sticky && addBtn && 'IntersectionObserver' in window) {

      var io = new IntersectionObserver(function (en) {

        var e = en[0];

        sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);

      });

      io.observe(addBtn);

      var sp = sticky.querySelector('[data-ht-sticky-price]');

      root.addEventListener('ht:variant', function (ev) { if (sp) sp.textContent = money(ev.detail.price); });

      if (sp && current) sp.textContent = money(current.price);

      var sbtn = sticky.querySelector('[data-ht-sticky-btn]');

      if (sbtn) sbtn.addEventListener('click', function () {

        var target = root.querySelector('.ht-bb__info');

        (target || root).scrollIntoView({ behavior: 'smooth', block: 'start' });

      });

    }

  }



  /* ---------- Reveal on scroll ---------- */

  function initReveal() {

    var els = document.querySelectorAll('.ht-reveal:not(.is-in)');

    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }

    var io = new IntersectionObserver(function (en) {

      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });

    }, { rootMargin: '0px 0px -8% 0px' });

    els.forEach(function (e) { io.observe(e); });

  }



  /* ---------- Track order ---------- */

  function initTrack() {

    document.querySelectorAll('[data-ht-track]').forEach(function (f) {

      if (f.__ht) return; f.__ht = true;

      f.addEventListener('submit', function (e) {

        e.preventDefault();

        var n = (f.querySelector('[name=tracking]').value || '').replace(/\s+/g, '');

        var out = f.querySelector('[data-ht-track-msg]');

        if (!n) { if (out) { out.hidden = false; out.textContent = 'Please enter your tracking number.'; } return; }

        var url = (f.dataset.provider || 'https://t.17track.net/en#nums=') + encodeURIComponent(n);

        window.open(url, '_blank', 'noopener');

      });

    });

  }



  /* ---------- Language / country selects (footer) ---------- */

  function initLocalization() {

    document.querySelectorAll('[data-ht-loc]').forEach(function (s) {

      if (s.__ht) return; s.__ht = true;

      s.addEventListener('change', function () { s.form.submit(); });

    });

  }



  function boot() {

    document.querySelectorAll('[data-ht-bb]').forEach(initBuybox);



    initReveal(); initTrack(); initLocalization();

  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('shopify:section:load', function () { boot(); });

})();

